/**
 * OneTrust Consent related constants
 */

/**
 * Cookie group IDs defined in OneTrust
 */
const ConsentGroup = {
    PERFORMANCE: 'C0002',
    FUNCTIONAL: 'C0003',
    TARGETING: 'C0004'
};

export {ConsentGroup};
